var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-subheading primary--text ml-2 mt-3 mb-5"},[_vm._v("General")]),_c('dynamic-input',{attrs:{"input":_vm.input,"fields":_vm.generalFields,"disabled":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }